import { actions } from "../../actions/action-list";
import initialState from "./initialState";

function Notification(state = initialState, action = {}) {
  switch (action.type) {
    case actions.NOTIFICATION:
      return { ...state, message: action.value };
    default:
      return state;
  }
}
export default Notification;
